export default __webpack_public_path__ + "static/media/date_l.e82f9b9d.svg";